module.exports = __webpack_public_path__ + "static/media/walrus.ccd213ab.png";